import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  fileUploadSuccess$ = new Subject<boolean>();
  fileUploadSuccess: boolean;

  onFileUploadSuccess() {
    this.fileUploadSuccess = true;
    this.fileUploadSuccess$.next(this.fileUploadSuccess);
  }

  onFileUploadError() {
    this.fileUploadSuccess = false;
    this.fileUploadSuccess$.next(this.fileUploadSuccess);
  }

  getFileUploadSuccessStatus() {
    return this.fileUploadSuccess;
  }
}
